import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HiOutlineChartBar,
  HiOutlineCube,
  HiOutlineShoppingBag,
  HiOutlineUsers,
  HiOutlineCash,
  HiOutlineMenuAlt2,
  HiOutlineX,
  HiOutlineShieldCheck,
  HiOutlineLightningBolt,
} from "react-icons/hi";

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();

  const menuItems = [
    {
      title: "Command Center",
      path: "/admin",
      icon: <HiOutlineChartBar size={20} />,
    },
    {
      title: "Hardware Catalog",
      path: "/admin/products",
      icon: <HiOutlineCube size={20} />,
    },
    {
      title: "Tactical Orders",
      path: "/admin/orders",
      icon: <HiOutlineShoppingBag size={20} />,
    },
    {
      title: "Player Database",
      path: "/admin/users",
      icon: <HiOutlineUsers size={20} />,
    },
    {
      title: "Credit Matrix",
      path: "/admin/credits",
      icon: <HiOutlineCash size={20} />,
    },
    {
      title: "Intelligence Review",
      path: "/admin/proposals",
      icon: <HiOutlineShieldCheck size={20} />,
    },
    {
      title: "Agent Command",
      path: "/admin/agents",
      icon: <HiOutlineLightningBolt size={20} />,
    },
  ];

  return (
    <div className="flex h-screen bg-[#0b0e14] overflow-hidden selection:bg-cyan-500/30">
      {/* Sidebar */}
      <aside
        className={`${
          isSidebarOpen ? "w-72" : "w-20"
        } bg-[#111827]/40 backdrop-blur-xl border-r border-white/5 transition-all duration-500 ease-in-out flex flex-col z-20 relative overflow-hidden`}
      >
        {/* Background Glow */}
        <div className="absolute top-0 left-0 w-full h-[500px] bg-purple-600/5 rounded-full blur-[100px] pointer-events-none -translate-x-1/2 -translate-y-1/2" />

        <div className="p-6 border-b border-white/5 flex items-center justify-between relative z-10">
          {isSidebarOpen && (
            <span className="text-xl font-black bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent uppercase italic tracking-widest">
              Command
            </span>
          )}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2.5 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl transition-all text-gray-400 hover:text-cyan-400 shadow-inner"
          >
            {isSidebarOpen ? (
              <HiOutlineX size={20} />
            ) : (
              <HiOutlineMenuAlt2 size={20} />
            )}
          </button>
        </div>

        <nav className="flex-1 p-6 space-y-3 relative z-10">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center p-4 rounded-2xl transition-all duration-300 group relative overflow-hidden ${
                location.pathname === item.path
                  ? "bg-cyan-500/10 border border-cyan-500/30 text-cyan-400 shadow-[0_0_20px_rgba(0,242,255,0.05)]"
                  : "text-gray-500 hover:bg-white/5 border border-transparent hover:border-white/5 hover:text-white"
              }`}
            >
              {/* Active Indicator */}
              {location.pathname === item.path && (
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-cyan-400 rounded-r-full shadow-[0_0_10px_#00f2ff]" />
              )}

              <span
                className={`transition-colors duration-300 ${
                  location.pathname === item.path
                    ? "text-cyan-400 drop-shadow-[0_0_8px_rgba(0,242,255,0.5)]"
                    : "text-gray-500 group-hover:text-cyan-300"
                }`}
              >
                {item.icon}
              </span>
              {isSidebarOpen && (
                <span className="ml-4 font-black uppercase text-[10px] tracking-[0.2em] italic truncate">
                  {item.title}
                </span>
              )}
            </Link>
          ))}
        </nav>

        <div className="p-6 border-t border-white/5 bg-black/20 relative z-10">
          <Link
            to="/"
            className="flex items-center p-4 rounded-xl text-[10px] font-black uppercase tracking-widest text-gray-500 hover:text-purple-400 transition-all group"
          >
            <HiOutlineMenuAlt2
              size={18}
              className="rotate-180 group-hover:-translate-x-1 transition-transform"
            />
            {isSidebarOpen && (
              <span className="ml-3 italic leading-none">Return to Front</span>
            )}
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto relative p-8 md:p-12">
        {/* Background Gradients */}
        <div className="fixed top-0 right-0 w-[800px] h-[800px] bg-cyan-500/5 rounded-full blur-[150px] pointer-events-none -z-10" />
        <div className="fixed bottom-0 left-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[150px] pointer-events-none -z-10" />

        <div className="max-w-7xl mx-auto">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
